module.exports = __webpack_public_path__ + "statics/img/cate8-1@2x.4e77da66.png";